var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import $_request from '../../utils/request';
var state = {
    questionList: [],
    questionType: [],
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_QUESTIONLIST: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        var data = Object.assign(params, {
            pageNo: 1,
            pageSize: 1000,
        });
        $_request({
            url: '/proxy/help/help/dfs/issue/list',
            method: 'post',
            data: data,
        }).then(function (res) {
            if (res.errorCode === 0 && res.data) {
                commit('update', {
                    questionList: res.data,
                });
            }
        });
    },
    GET_QUESTIONTYPE: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        var data = Object.assign({}, params);
        $_request({
            url: '/proxy/help/help/dfs/issue/type/list',
            method: 'post',
            data: data,
        }).then(function (res) {
            if (!res.errorCode) {
                var list_1 = [];
                res.data.forEach(function (item) {
                    list_1.push(__assign({}, item, { list: [] }));
                });
                commit('update', {
                    questionType: list_1,
                });
            }
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
